export const computeIfAbsent = <K, V>( map: Map<K, V>, key: K, mapper: ( k: K ) => V ): V => {
    const value = map.get( key );
    if ( value == null ) {
        const computedValue = mapper( key );
        map.set( key, computedValue );
        return computedValue;
    } else {
        return value;
    }
};

export const putIfAbsent = <K, V>( map: Map<K, V>, key: K, value: V ): V => {
    const v = map.get( key );
    if ( v == null ) {
        map.set( key, value );
        return value;
    } else {
        return v;
    }
};
